const FooterComponent = () => {
  return (
    <p className="clearfix mb-0">
      <span className="float-md-left d-block d-md-inline-block mt-25">
        COPYRIGHT © 2021
        {/*{new Date().getFullYear()}*/}{" "}
        <a
          href="https://howtoyak.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          HowToYak
        </a>
        <span className="d-none d-sm-inline-block">, All rights Reserved</span>
      </span>
      <span className="float-md-right d-none d-md-block">
        Hand-crafted & Made with
      </span>
    </p>
  );
};

export default FooterComponent;
